<app-header></app-header>
<!-- Begin page content -->
<main role="main" class="container-fluid">
  <ngx-ui-loader></ngx-ui-loader>
  <div class="container-fluid mt-2 main" ngxUiLoaderBlurred>
    <router-outlet></router-outlet>
    <div class="authenticating-error" *ngIf="(isDoneLoading | async) && error">
      <div>Vous n'êtes pas authentifié.</div>
      <div><button class="btn btn-secondary" (click)="login()">Se connecter</button></div>
    </div>
  </div>
</main>